export type SortOrder = {
  columnId: string
  direction: "asc" | "desc"
}

export type SortOrderValue = "Ascending" | "Descending"

export type GraphQLSortOrder = {
  [key: string]: SortOrderValue
}

export const DIRECTION_MAP = {
  asc: "Ascending",
  desc: "Descending",
}

export const CONDITION_MAP = {
  is: "equals",
  includes: "in",
  "=": "equals",
  "<": "lessThan",
  "<=": "lessThanOrEqual",
  ">": "greaterThan",
  ">=": "greaterThanOrEqual",
  "!=": "notEquals",
  isEmpty: "isNotSet",
  isNotEmpty: "isSet",
  isFalse: "equals",
  isTrue: "equals",
}

export type FilterStack = {
  filters?: FilterStack[]
  operator: keyof typeof CONDITION_MAP | "or" | "and"
  id?: string
  columnId?: string
  value?: number | string | boolean
}

export type GraphQLFilterExpression = {
  [key: string]: {
    [condition: string]: number | string | boolean
  }
}

export type GraphQLFilter =
  | {
      [operator: string]: GraphQLFilterExpression[] | GraphQLFilterExpression | GraphQLFilter
    }
  | {
      AND: GraphQLFilterExpression[] | GraphQLFilterExpression | GraphQLFilter
    }
  | {
      OR: GraphQLFilterExpression[] | GraphQLFilterExpression | GraphQLFilter
    }
  | {
      NOT: GraphQLFilterExpression[] | GraphQLFilterExpression | GraphQLFilter
    }
  | GraphQLFilter[]
